<template>
  <div class="floors">
    <NavigationBar />
    <div class="table-and-box is-hidden-tablet">
      <div class="upper-panel">
        <BuildingsTable id="table" />
      </div>
      <div class="lower-panel">
        <FloorCardsBox
          v-if="this.$store.getters.selectedBuilding !== undefined"
          id="box"
        />
        <div v-else id="box-empty">
          Please select or add a building.
          <br />
          You will see its floors here.
        </div>
      </div>
    </div>
    <div class="table-and-box columns is-gapless is-hidden-mobile">
      <div class="column is-one-fifth left-panel">
        <BuildingsTable id="table" />
      </div>
      <div class="column">
        <FloorCardsBox
          v-if="this.$store.getters.selectedBuilding !== undefined"
          id="box"
        />
        <div v-else id="box">
          Please select or add a building from the panel on the left.
          <br />
          You will see its floors here.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BuildingsTable from "@/components/BuildingsTable.vue";
import FloorCardsBox from "@/components/FloorCardsBox.vue";
import NavigationBar from "@/components/NavigationBar.vue";
import { NotificationProgrammatic as Notification } from "buefy/dist/components/notification";
import { getAllData } from "../api-requests";

export default {
  name: "locations",
  components: { BuildingsTable, NavigationBar, FloorCardsBox },
  data() {
    return {};
  },
  computed: {},
  methods: {
    isExampleDataPresent: function() {
      const example_buildings = this.$store.state.buildings.filter(building =>
        building.name.endsWith("(Example)")
      );
      return example_buildings.length > 0;
    },
    displayExampleDataInfoPanel: function() {
      if (this.$store.getters.shouldDisplayExampleDataInfoPanel) {
        Notification.open({
          message: `We created some example data for you to play with!<br><br>
          You can delete it anytime by:<br>
          1. Clicking on the building name.<br>
          2. Selecting the three dots icon.<br>
          3. Clicking the delete button.`,
          indefinite: true,
          position: "is-bottom-right",
          type: "is-info",
          hasIcon: true
        });
        this.$store.commit("setShouldDisplayExampleDataInfoPanelToFalse");
        // Event emited when closing can be handled in Buefy version >= v.8.9.0.
        // notif.$on("close", () => { console.log("Closed the notification."); });
      }
    },
    maybeDisplayExampleDataInfoPanel: function() {
      if (this.isExampleDataPresent()) {
        this.displayExampleDataInfoPanel();
      }
    },
    displayFloorSelectionViewInfoPanel: function() {
      if (this.$store.getters.shouldDisplayFloorSelectionViewInfoPanel) {
        Notification.open({
          message: `Welcome to the floor selection view!<br><br>
          &bull; Select and add buildings from the left panel.<br>
          &bull; Select and add floors from the main panel.<br>
          &bull; Rename and delete items using the three dots icon.<br>
          &bull; Use the search in the top bar to find any location by its name.`,
          // &bull; Select a building from the left panel to see its floors.<br>
          // &bull; Select a floor from the main panel to view it.<br>
          // &bull; Add a building using the button in the top-left corner.<br>
          // &bull; Add a floor using the "Add new floor" button in the main panel.`,
          // &bull; Add a floor using the "Add new floor" button in the main panel.<br>
          // &bull; Rename and delete items using the three dots menu.<br>
          // &bull; Use the search in the top bar to find any location by its name.`,
          indefinite: true,
          position: "is-bottom-right",
          type: "is-info",
          hasIcon: true
        });
        this.$store.commit(
          "setShouldDisplayFloorSelectionViewInfoPanelToFalse"
        );
        // Event emited when closing can be handled in Buefy version >= v.8.9.0.
        // notif.$on("close", () => { console.log("Closed the notification."); });
      }
    }
  },
  mounted: async function() {
    await getAllData();
    setTimeout(() => {
      this.maybeDisplayExampleDataInfoPanel();
    }, 1500);
    // setTimeout(() => {
    //   this.displayFloorSelectionViewInfoPanel();
    // }, 1500);
  }
};
</script>

<style scoped>
#box {
  height: 100%;
  overflow-y: auto;
}

@media (min-width: 768px) {
  .floors {
    display: flex;
    flex-flow: column;
    height: 100%;
  }
  .table-and-box {
    flex-grow: 1;
  }
  #table {
    height: 100%;
    overflow-y: auto;
  }
  #box {
    padding: 30px;
  }
  .left-panel {
    border-right: 1px solid #dbdbdb;
    min-width: 340px;
  }
}

@media (max-width: 768px) {
  .floors {
    height: var(--app-height);
  }
  .table-and-box {
    display: flex;
    flex-flow: column;
    height: calc(var(--app-height) - 57px);
  }
  #table {
    height: 100%;
    overflow-y: auto;
    border-bottom: 1px solid #dbdbdb;
  }
  #box {
    padding: 17px;
  }
  #box-empty {
    padding: 17px;
    padding-top: 50px;
  }
  .upper-panel {
    height: 40%;
  }
  .lower-panel {
    height: 60%;
  }
}

/* To show the scrollbar on mobile, always. */
::-webkit-scrollbar {
  -webkit-appearance: none;
}
::-webkit-scrollbar:vertical {
  width: 12px;
}
::-webkit-scrollbar:horizontal {
  height: 12px;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  border: 2px solid #ffffff;
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #ffffff;
}
</style>
